import React, { useState, useEffect } from 'react';

function EntryForm({ editingEntry, onFormSubmit, onCancel, submitting }) {
  const [formData, setFormData] = useState({
    name: '',
    guests: '',
    dishes: ''
  });

  useEffect(() => {
    if (editingEntry) {
      setFormData({
        name: editingEntry.name || '',
        guests: editingEntry.guests || '',
        dishes: editingEntry.dishes || ''
      });
    } else {
      setFormData({
        name: '',
        guests: '',
        dishes: ''
      });
    }
  }, [editingEntry]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(formData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="entry-form">
      <h2>{editingEntry ? 'Edit Entry' : 'Add New Entry'}</h2>
      
      <div className="form-group">
        <label htmlFor="name">Name *</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Your name"
          disabled={submitting}
        />
      </div>

      <div className="form-group">
        <label htmlFor="guests">Who's Coming</label>
        <input
          type="text"
          id="guests"
          name="guests"
          value={formData.guests}
          onChange={handleChange}
          placeholder="Names of people coming with you"
          disabled={submitting}
        />
      </div>

      <div className="form-group">
        <label htmlFor="dishes">Dishes You're Bringing</label>
        <textarea
          id="dishes"
          name="dishes"
          value={formData.dishes}
          onChange={handleChange}
          rows="4"
          placeholder="Turkey, Mashed Potatoes, Green Bean Casserole (separate with commas)"
          disabled={submitting}
        />
      </div>

      <div className="form-actions">
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? (
            <>
              <span className="spinner"></span>
              {editingEntry ? 'Updating...' : 'Adding...'}
            </>
          ) : (
            editingEntry ? 'Update Entry' : 'Add Entry'
          )}
        </button>
        {editingEntry && (
          <button type="button" onClick={onCancel} className="btn btn-secondary" disabled={submitting}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default EntryForm;

